<template>
	<div class="session-control-rtmp">
		<ui-checkbox
			v-model="ssl"
			label="Use a secure connection (TLS/SSL)"
		/>
		<ui-clipboard-input
			:value="rtmpUrl"
			hint="Link copied to clipboard"
			label="Stream URL"
		/>
		<div class="ui-caption">
			<p>You can record by adding the stream URL to any third-party device or services supporting RTMP(S). The recording starts as soon as the remote side starts feeding to your stream URL.</p>
			<p>The cloud service supports receiving and recording multiple RTMP(S) sessions at the same time. Each session will result in a recording. The cloud service captures in the quality sent from the remote side, e.g. 720p, 1080p or 4K.</p>
			<p>While your subscription includes recording and storage of videos in 720p quality we welcome that you also record and store videos in higher qualities. We reserve the right to introduce limitations and/or introduce subscription tiers based on video quality in the future.</p>
		</div>
	</div>
</template>

<script>
import UiCheckbox from "lib/components/ui/Checkbox";
import UiClipboardInput from "lib/components/ui/ClipboardInput";

export default {
	name: "SessionControlRtmp",
	components: {
		UiCheckbox,
		UiClipboardInput
	},
	props: {
		recorder: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			ssl: true
		};
	},
	computed: {
		rtmpUrl() {
			const host = this.recorder.server.hostname.replace(/rec\.vc/gi, "vpop.vc");
			const port = this.ssl ? 1936 : 1935;
			const protocol = this.ssl ? "rtmps" : "rtmp";

			return `${protocol}://${host}:${port}/rec/${this.recorder.recorder_id}`;
		}
	}
};
</script>
